/**
 * Firebase Environment Configurations
 *
 * Maps project_id to Firebase configuration for different environments.
 * Each environment (dev, uat, production) has its own Firebase project settings.
 */

/**
 * Firestore Emulator Configuration
 * Used when running locally against the Firestore emulator
 */
export const FIRESTORE_EMULATOR_HOST = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || 'localhost';
export const FIRESTORE_EMULATOR_PORT = parseInt(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || '9097', 10);
export const DEFAULT_FIRESTORE_EMULATOR_URL = `${FIRESTORE_EMULATOR_HOST}:${FIRESTORE_EMULATOR_PORT}`;

export interface FirebaseEnvironmentConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

/**
 * Dictionary mapping project_id to Firebase configuration
 */
export const firebaseEnvironments: Record<string, FirebaseEnvironmentConfig> = {
  'fivesigma-cms-dev': {
    apiKey: 'AIzaSyABRZWY5CpYrMVa2jmCGeZLxm0abfiFrRo',
    authDomain: 'fivesigma-cms-dev.firebaseapp.com',
    projectId: 'fivesigma-cms-dev',
    storageBucket: 'fivesigma-cms-dev.firebasestorage.app',
    messagingSenderId: '1013776867538',
    appId: '1:1013776867538:web:d99cec5caa1b94e4a38d0b',
  },
  'fivesigma-cms-uat': {
    apiKey: 'AIzaSyCsTHCnxaWmA49emoDc_LKDNEMGX79lDG8',
    authDomain: 'fivesigma-cms-uat.firebaseapp.com',
    projectId: 'fivesigma-cms-uat',
    storageBucket: 'fivesigma-cms-uat.firebasestorage.app',
    messagingSenderId: '129870584641',
    appId: '1:129870584641:web:d74ae5cff68f0be08edfc0',
  },
  // Add more environments as needed:
  // 'fivesigma-cms-prod': { ... },
};

/**
 * Get Firebase configuration for a specific project_id
 * @param projectId - The project ID from FirestoreConfig
 * @returns Firebase configuration or null if not found
 */
export const getFirebaseConfig = (projectId: string): FirebaseEnvironmentConfig | null => {
  return firebaseEnvironments[projectId] || null;
};
